import React from 'react'
import Link from 'next/link'
import Image from 'next/image';
import SectionHeading from '../../Common/SectionHeading';

export default function ServiceSection({data=null}) {
    return (
        <>
            {(data) &&
                <>
                    {data?.map((item, index) => (
                        <section key={index} className="flex flex-col justify-center w-11/12 mx-auto my-6 xl:max-w-screen max-w-screen-2xl lg:my-10">
                            <div className="grid grid-cols-12 gap-4">
                                <div className="col-span-12 md:col-span-3">
                                    <div className={`h-full p-4 lg:p-8 bg-repeat`} style={{backgroundImage: `url(${process.env.IMG_CDN+'img/researchCoverage/dot-pattern.png'})`}}>
                                        <SectionHeading 
                                            title={item?.title}
                                            
                                            customClass='text-left dark:text-black'
                                        />
                                        <p className="font-semibold dark:text-black">
                                            {item?.shortTitle}
                                        </p>
                                        <p className='dark:text-black line-clamp-5 lg:line-clamp-none'>
                                            {item?.description}
                                        </p>
                                        <Link
                                            href={process.env.APP_URL+item?.link}
                                            className="capitalize text-center dark:text-black mt-10 block text-sm bg-[#1b5df3] text-white font-semibold rounded px-6 py-2"
                                        >
                                            {item?.btnTitle}
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-span-12 md:col-span-9">
                                    <div className="grid grid-cols-12 gap-4">
                                        {item?.listPoints.map((point, pointIndex) => (
                                            <div key={`${index}-${pointIndex}`} className="col-span-12 md:col-span-4">
                                                <div className="relative overflow-hidden text-center group">
                                                    <div className="relative m-0 overflow-hidden h-72">
                                                        <div className={`flex items-center justify-center w-full h-full m-0 bg-repeat`} style={{backgroundImage: `url(${process.env.IMG_CDN+'img/researchCoverage/dot-pattern.png'})`}}>
                                                            <Image priority={false} 
                                                                className="p-5 w-28 h-28"
                                                                width={2000} 
                                                                height={2000} 
                                                                src={process.env.IMG_CDN+point.imageSrc} 
                                                                alt={point.altText}
                                                            />
                                                            <h3 className="text-lg m-0 leading-1 font-semibold text-md text-[#232323] pb-5 hidden">{point.title}</h3>
                                                        </div>
                                                        <div className={`block group-hover:left-0 absolute top-2 bottom-2 left-[-100%] w-full h-full m-0 overflow-hidden transition-all duration-300 ease-in-out  bg-repeat`} style={{backgroundImage: `url(${process.env.IMG_CDN+'img/researchCoverage/dot-pattern.png'})`}}>
                                                            <div className="relative h-full">
                                                                <h3 className="text-lg font-semibold dark:text-black group-hover:uppercase">{point.title}</h3>
                                                                <p className="dark:text-black px-6 group-hover:left-0  absolute text-md leading-2 m-0 w-full top-[40px] left-[-150px] transition-all duration-300 ease-in-out">
                                                                    {point.description}
                                                                </p>
                                                                <Link 
                                                                    href={process.env.APP_URL+point.link}
                                                                    className="dark:text-black font-semibold group-hover:bottom-[9px] group-hover:m-0 group-hover:left-0 group-hover:right-0 py-3 absolute text-md leading-2 m-0 w-full bottom-[-150px] left-[-50px] right-[-50px] bg-[rgba(0,0,0,.04)] transition-all duration-300 ease-in-out delay-200">
                                                                    {point.btnTitle}
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </section>
                    ))}
                </>
            }
        </>
    )
}
